import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "./Reveal";

export const CTA = () => (
  <section data-testid="cta-section" className="bg-paper py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="relative overflow-hidden rounded-[28px] bg-ink text-paper px-6 py-16 sm:px-14 sm:py-24 grain">
        <div className="pointer-events-none absolute right-[-10%] bottom-[-40%] w-[70%] aspect-square rounded-full bg-[radial-gradient(circle,rgba(29,63,168,0.35),transparent_65%)]" />
        <h2 className="relative font-display font-extrabold tracking-[-0.03em] leading-[0.95] text-4xl sm:text-6xl lg:text-7xl max-w-4xl">
          <MaskLines inView lines={[<>Your next inspection</>, <>should feel <span className="font-serif-i text-brass">routine.</span></>]} />
        </h2>
        <Reveal delay={0.2} className="relative mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
          <Link to="/contact" data-testid="cta-contact-button" className="group inline-flex items-center justify-center gap-2 rounded-full bg-brass text-paper px-7 py-4 font-semibold hover:bg-paper hover:text-ink transition-colors duration-300">
            Start a conversation <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <Link to="/services" data-testid="cta-services-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-paper/30 px-7 py-4 font-semibold hover:border-[#93a8e8] hover:text-[#93a8e8] transition-colors duration-300">
            Explore services
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
